import React from 'react'
import { Col } from 'react-bootstrap'
import { StyledCardContainer, StyledImage, StyledTitle } from './styled'

const SegmentCard = (props) => {
    return(
        <StyledCardContainer>
            <Col xs={12} className='d-flex justify-content-center align-items-center flex-column'>
                <StyledImage src={props.image.url} alt={props.image.alt} />
                <StyledTitle>
                    {props.title}
                </StyledTitle>
            </Col>
        </StyledCardContainer>
    )
}

export default SegmentCard